import React, { createContext } from 'react';

export const ChartsContext = createContext<any | undefined>(undefined);
